export default "__VITE_ASSET__54535eda__"